import serviceAxios from "./request";
// 字典
export const configbaseDictData = (params) => {
  return serviceAxios({
    url: "/app/config/baseDictData",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 首页信息
export const configbase = (params) => {
  return serviceAxios({
    url: "/app/config/base",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************登录*********************/
// 获取手机验证码
export const smsmobile = (params) => {
  return serviceAxios({
    url: "/app/sms/mobile",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 获取邮箱验证码
export const smsemail = (params) => {
  return serviceAxios({
    url: "/app/sms/email",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 帐号注册
export const authMemberregister = (data) => {
  return serviceAxios({
    url: "/app/authMember/register",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 账号密码登录
export const authMemberloginByPassword = (data) => {
  return serviceAxios({
    url: "/app/authMember/loginByPassword",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 账号验证码登录
export const authMemberloginByCode = (data) => {
  return serviceAxios({
    url: "/app/authMember/loginByCode",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 获取个人信息
export const authMemberinfo = (params) => {
  return serviceAxios({
    url: "/app/authMember/info",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 个人信息更新
export const authMemberprofile = (data) => {
  return serviceAxios({
    url: "/app/authMember/profile",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 绑定手机号
export const authMemberbindMobile = (params) => {
  return serviceAxios({
    url: "/app/authMember/bindMobile",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 绑定邮箱
export const authMemberbindEmail = (params) => {
  return serviceAxios({
    url: "/app/authMember/bindEmail",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************首页*********************/
// 运输路线列表
export const transportLinelineList = (params) => {
  return serviceAxios({
    url: "/app/transportLine/lineList",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 自提点列表
export const selfPickUpSiteList = (params) => {
  return serviceAxios({
    url: "/app/selfPickUpSite/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 国家列表(全部启用的)
export const countrylist = (params) => {
  return serviceAxios({
    url: "/app/country/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 仓库列表(全部正常的)
export const warehouselist = (params) => {
  return serviceAxios({
    url: "/app/warehouse/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 物品品类列表
export const packageGoodsTypeList = (params) => {
  return serviceAxios({
    url: "/app/packageGoodsType/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 运费预估路线详情
export const freightEstimateLineDetail = (params) => {
  return serviceAxios({
    url: "/app/transportLine/freightEstimateLineDetail",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 运费预估路线列表
export const freightEstimateLineList = (params) => {
  return serviceAxios({
    url: "/app/transportLine/freightEstimateLineList",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 运输路线详情(包含网格、价格)
export const transportLinelineDetail = (params) => {
  return serviceAxios({
    url: "/app/transportLine/lineDetail",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 物流查询
export const transportOrderlogisticsChange = (params) => {
  return serviceAxios({
    url: "/app/transportOrder/logisticsChange",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 文章列表
export const articlelist = (params) => {
  return serviceAxios({
    url: "/app/article/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 文章详情
export const articledetail = (params) => {
  return serviceAxios({
    url: "/app/article/detail",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************代购部分*********************/
// 代购首页信息
export const homeindex = (params) => {
  return serviceAxios({
    url: "/app/home/index",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 商品列表
export const goodslist = (params) => {
  return serviceAxios({
    url: "/app/goods/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 收藏列表
export const collectList = (params) => {
  return serviceAxios({
    url: "/app/collect/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 取消收藏
export const goodsCollect = (params) => {
  return serviceAxios({
    url: "/app/goods/collect",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 推荐商品分类和商品分类列表（含子分类）
export const goodsCategoryrecommendAndTree = (params) => {
  return serviceAxios({
    url: "/app/goodsCategory/recommendAndTree",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************购物车部分*********************/
// 我的购物车
export const cartlist = (params) => {
  return serviceAxios({
    url: "/app/cart/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 购物车数量
export const cartcount = (params) => {
  return serviceAxios({
    url: "/app/cart/count",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 购物车价格（已选中商品总价）
export const cartcartPrice = (params) => {
  return serviceAxios({
    url: "/app/cart/cartPrice",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 修改购物车商品数量
export const cartupdateNumber = (params) => {
  return serviceAxios({
    url: "/app/cart/updateNumber",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 删除购物车(批量)
export const cartdelete = (params) => {
  return serviceAxios({
    url: "/app/cart/delete",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 购物车选择/取消选择
export const cartcheck = (params) => {
  return serviceAxios({
    url: "/app/cart/check",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 购物车全选/取消全选
export const cartcheckAll = (params) => {
  return serviceAxios({
    url: "/app/cart/checkAll",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 商品详情
export const goodsdetail = (params) => {
  return serviceAxios({
    url: "/app/goods/detail",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 加入购物车
export const cartadd = (data) => {
  return serviceAxios({
    url: "/app/cart/add",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 结算
export const cartsettlement = (data) => {
  return serviceAxios({
    url: "/app/cart/settlement",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 提交订单（按店铺拆单，返回合并支付单）
export const cartsubmit = (data) => {
  return serviceAxios({
    url: "/app/cart/submit",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 订单支付详情
export const orderpayDetail = (params) => {
  return serviceAxios({
    url: "/app/order/payDetail",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************代购订单部分*********************/
// 我的订单列表
export const orderlist = (params) => {
  return serviceAxios({
    url: "/app/order/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 取消订单
export const ordercancel = (data) => {
  return serviceAxios({
    url: "/app/order/cancel",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 订单详情
export const orderdetail = (params) => {
  return serviceAxios({
    url: `/app/order/detail/${params.orderPayId}`,
    method: "get",
    params:{},
	headers:{"Content-Type":"application/json"}
  });
};
// 申请售后页回显
export const orderapplyInfo = (params) => {
  return serviceAxios({
    url: `/app/order/rights/applyInfo/${params.id}`,
    method: "get",
    params:{},
	headers:{"Content-Type":"application/json"}
  });
};
// 提交售后申请
export const orderapply = (data) => {
  return serviceAxios({
    url: "/app/order/rights/apply",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 字典拿退款类型
export const returnTypeAll = (params) => {
  return serviceAxios({
    url: "/app/config/baseDictData",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 订单支付（按合并支付单支付，支持多店铺）
export const orderpay = (params) => {
  return serviceAxios({
    url: "/app/order/pay",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************物流地址部分*********************/
// 我的地址列表
export const memberAddresslist = (params) => {
  return serviceAxios({
    url: "/app/memberAddress/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 删除地址
export const memberAddressDelete = (data) => {
  return serviceAxios({
    url:`/app/memberAddress/delete/${data.id}`,
    method: "post",
	headers:{"Content-Type":"application/json"}
  });
};
// 地址详情
export const memberAddressDetail = (data) => {
  return serviceAxios({
    url: `/app/memberAddress/detail/${data.id}`,
    method: "get",
	headers:{"Content-Type":"application/json"}
  });
};
// 新增地址
export const memberAddressAdd = (data) => {
  return serviceAxios({
    url: "/app/memberAddress/add",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 更新地址
export const memberAddressUpdate = (data) => {
  return serviceAxios({
    url: "/app/memberAddress/update",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************优惠券*********************/
// 运费优惠券列表
export const freightCouponAvailable = (params) => {
  return serviceAxios({
    url: "/app/freightCoupon/available",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 代购优惠券列表
export const couponAvailable = (params) => {
  return serviceAxios({
    url: "/app/coupon/available",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 领取运费券
export const freightCouponReceive = (params) => {
  return serviceAxios({
    url: "/app/freightCoupon/receive",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 领取代购券
export const couponReceive = (params) => {
  return serviceAxios({
    url: "/app/coupon/receive",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 我的优惠券
export const couponmyCoupon = (params) => {
  return serviceAxios({
    url: "/app/coupon/myCoupon",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 我的运费优惠券
export const freightCouponmyCoupon = (params) => {
  return serviceAxios({
    url: "/app/freightCoupon/myCoupon",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************包裹部分*********************/
// 包裹列表
export const packagelist = (params) => {
  return serviceAxios({
    url: "/app/package/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 删除包裹
export const packageremove = (params) => {
  return serviceAxios({
    url: "/app/package/remove",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 包裹预报
export const packageforecast = (data) => {
  return serviceAxios({
    url: "/app/package/forecast",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 批量预报
export const packagebatchForecast = (data) => {
  return serviceAxios({
    url: "/app/package/batchForecast",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 获取包裹详细信息
export const packagedetail = (params) => {
  return serviceAxios({
    url: "/app/package/detail",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 修改包裹
export const packageedit = (data) => {
  return serviceAxios({
    url: "/app/package/edit",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 包裹列表(未认领包裹)
export const packageunclaimedList = (params) => {
  return serviceAxios({
    url: "/app/package/unclaimedList",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 认领包裹
export const packageclaim = (data) => {
  return serviceAxios({
    url: "/app/package/claim",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************唛头部分*********************/
// 我的唛头列表
export const memberMarklist = (params) => {
  return serviceAxios({
    url: "/app/memberMark/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 唛头详情
export const memberMarkdetail = (params) => {
  return serviceAxios({
    url: "/app/memberMark/detail",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 新增唛头
export const memberMarkadd = (data) => {
  return serviceAxios({
    url: "/app/memberMark/add",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 修改唛头
export const memberMarkupdate = (data) => {
  return serviceAxios({
    url: "/app/memberMark/update",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 删除唛头
export const memberMarkdelete = (data) => {
  return serviceAxios({
    url:`/app/memberMark/delete/${data.id}`,
    method: "post",
    data:{},
	headers:{"Content-Type":"application/json"}
  });
};
/*********************平台首页*********************/
// 个人页面用户相关信息
export const memberindex = (params) => {
  return serviceAxios({
    url: "/app/member/index",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 公告列表
export const noticelist = (params) => {
  return serviceAxios({
    url: "/app/notice/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 公告详情
export const noticedetail = (params) => {
  return serviceAxios({
    url: "/app/notice/detail",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************物流订单*********************/
// 我的订单列表
export const transportOrderlist = (params) => {
  return serviceAxios({
    url: "/app/transportOrder/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 我的订单详情(含包裹+增值服务+轨迹+支付记录)
export const transportOrderdetail = (data) => {
  return serviceAxios({
    url: `/app/transportOrder/detail/${data.id}`,
    method: "get",
    data:{},
	headers:{"Content-Type":"application/json"}
  });
};
// 取消订单
export const transportOrdercancel = (params) => {
  return serviceAxios({
    url: "/app/transportOrder/cancel",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 删除订单
export const transportOrderremoveById = (params) => {
  return serviceAxios({
    url: "/app/transportOrder/removeById",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 签收订单
export const transportOrdersignOrder = (data) => {
  return serviceAxios({
    url: "/app/transportOrder/signOrder",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 订单支付
export const transportOrderpay = (params) => {
  return serviceAxios({
    url: "/app/transportOrder/pay",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
/*********************物流下单*********************/
// 增值服务列表(启用的)
export const appreciationlist = (params) => {
  return serviceAxios({
    url: "/app/appreciation/list",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 运输方式列表(启用的)
export const transportLinemodeList = (params) => {
  return serviceAxios({
    url: "/app/transportLine/modeList",
    method: "get",
    params,
	headers:{"Content-Type":"application/json"}
  });
};
// 创建运输订单
export const transportOrdercreate = (data) => {
  return serviceAxios({
    url: "/app/transportOrder/create",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};
// 立即下单(数据回显)
export const transportOrderpreview = (data) => {
  return serviceAxios({
    url: "/app/transportOrder/preview",
    method: "post",
    data,
	headers:{"Content-Type":"application/json"}
  });
};